import { DataType } from 'components/table/types';
import { NewAccountStatus } from 'constants/new_accounts.constants';

export type tableColumns = Record<NewAccountStatus, Record<string, DataType>>;
export const tableColumns: tableColumns = {
	[NewAccountStatus.DRAFT]: {
		createdAt: 'date',
		entityType: 'string',
		identityNumber: 'string',
		accountNameHebrew: 'string',
		accountNameEnglish: 'string',
		maxForPayment: 'integer',
		maxForConvert: 'integer',
		currentStep: 'string',
		deleteAction: 'custom',
	},
	[NewAccountStatus.IN_REVIEW]: {
		createdAt: 'date',
		hyperAccountNumber: 'string',
		accountNameHebrew: 'string',
		accountNameEnglish: 'string',
		entityType: 'string',
		creationSource: 'custom',
		deleteAction: 'custom',
	},
	[NewAccountStatus.DENIED]: {
		createdAt: 'date',
		entityType: 'string',
		identityNumber: 'string',
		accountNameHebrew: 'string',
		accountNameEnglish: 'string',
		maxForPayment: 'integer',
		maxForConvert: 'integer',
		boNotes: 'custom',
		deleteAction: 'custom',
	},
	[NewAccountStatus.APPROVED]: {},
};
